import React, { useEffect, useState } from "react";
import { useAdminContext } from "../Hooks/AdminContext";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import {
  _Website_Settings_List,
  _Website_Settings_List_Update,
} from "../DAL/Listing/WebsiteSetting";
import CustomCircularProgress from "../components/CustomCircularProgress";

export const StripeSettings = () => {
  const { setnavbarTitle } = useAdminContext();
  const [loading, setLoading] = useState(true);

  const [stripeSettings, setStripeSettings] = useState({
    stripe_mode: "sandBox",
    sandBox_publish_key: "",
    sandBox_secret_key: "",
    live_publish_key: "",
    live_secret_key: "",
  });

  useEffect(() => {
    setnavbarTitle("Stripe Settings");
    fetchStripeSettings();
  }, []);

  const fetchStripeSettings = async () => {
    setLoading(true);
    const response = await _Website_Settings_List({ type: "stripe" });
    if (response.code === 200) {
      setStripeSettings(response.settings);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStripeSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const response = await _Website_Settings_List_Update({
      type: "stripe",
      settings: stripeSettings,
    });

    if (response.code === 200) {
      enqueueSnackbar("Stripe settings updated successfully", {
        variant: "success",
      });
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setLoading(false);
  };
  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="row mt-3">
      {/* Sandbox Keys */}
      <form onSubmit={handleSubmit} className="row">
        <div className="col-12 col-md-6 mt-3">
          <TextField
            fullWidth
            label="Sandbox Publish Key"
            variant="outlined"
            required
            name="sandBox_publish_key"
            value={stripeSettings.sandBox_publish_key}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <TextField
            fullWidth
            label="Sandbox Secret Key"
            variant="outlined"
            required
            name="sandBox_secret_key"
            value={stripeSettings.sandBox_secret_key}
            onChange={handleChange}
          />
        </div>

        {/* Live Keys */}
        <div className="col-12 col-md-6 mt-3">
          <TextField
            required
            fullWidth
            label="Live Publish Key"
            variant="outlined"
            name="live_publish_key"
            value={stripeSettings.live_publish_key}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <TextField
            fullWidth
            required
            label="Live Secret Key"
            variant="outlined"
            name="live_secret_key"
            value={stripeSettings.live_secret_key}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mt-3">
          <FormControl fullWidth>
            <InputLabel>Stripe Mode</InputLabel>
            <Select
              value={stripeSettings.stripe_mode}
              label="Stripe Mode"
              onChange={handleChange}
              name="stripe_mode"
            >
              <MenuItem value="sandBox">Sandbox</MenuItem>
              <MenuItem value="live">Live</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="col-12 mt-3 text-end">
          <Button
            variant="contained"
            className="small-contained-button"
            type="submit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};
